import { AppLinks } from '../../enviroment/AppLinks'

// Tablica z podstronami na których NIE POKAZUJEMY navbara aplikacji
export const pagesWithNoNavbar = [
   AppLinks.home,
   AppLinks.waiting,
   AppLinks.start,
   AppLinks.bmWaiting,
]


// Tablica z podstronami na których NIE POKAZUJEMY stopki aplikacji
export const pagesWithNoFooter = [
   AppLinks.home,
   AppLinks.waiting,
   AppLinks.start,
   AppLinks.bmWaiting
]

